<template>
    <!-- 补充资料 -->
    <common-modal :is-show-close="isShowClose" @close="close">
        <div class="wang-wrap">
            <h1>选择卖家旺旺</h1>
            <ul class="wang-list">
                <li v-for='(item,index) in wangList' :key='index'>
                    <span class="modal-title">{{item.wangwang}}</span>
                    <span class="select-mark" :class='wangFlag==index?"current":""' @click="wangFlag = index;"></span>
                </li>
            </ul>
            <div class="modal-submit" @click="submitWang">确定</div>
        </div>
    </common-modal>
</template>

<script>
import commonModal from '@/components/commonModal.vue';
export default {
    components: {
        commonModal
    },
    
    props:{
        wangList:{
            type:Array,
            default:()=>[]
        }
    },
    
    data() {
        return {
            wangFlag:0,
            isShowClose: true
        };
    },

    methods: {
        close() {
            this.$emit('close');
        },
        
        submitWang(){
            let wangWang = this.wangList[this.wangFlag].wangwang
            this.$emit("submitWang",wangWang)
        }
    }
};
</script>

<style lang="scss" scoped>
    
>>>.dialog-detail{
    width: 440px !important ;
    .wang-wrap {
        padding-bottom: 20px;
        h1 {
            border-bottom: 0.026667rem solid #e9e9e9;
            padding: 15px;
            text-align: center;
            @include font-style;
            font-size: 20px;
            color: #000000;
        }
        .wang-list {
            height: 480px;
            overflow-y: auto;
            box-sizing: border-box;
            padding: 30px;
            background: #ffffff;
            line-height: 30px;
            letter-spacing: 2px;
            li{
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 12px;
                cursor: pointer;
                .modal-title{
                    font-size: 20px;
                    color: #141414;
                    max-width: 88%;
                }
                .select-mark{
                    width: 20px;
                    height: 20px;
                    @include font-style;
                    background: url(../assets/img/un-select.png) no-repeat left center;
                    background-size: 20px;
                }
    
                .current{
                    background: url(../assets/img/select.png) no-repeat left center;
                    background-size: 20px;
                } 
            } 
        }
        .modal-submit{
            cursor: pointer;
            width: 80%;
            height:44px;
            margin: 0 auto;
            line-height: 44px;
            border-radius: 3px;
            font-size: 20px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            background: #fe860e;
            text-align: center;
            color: #ffffff;
        }
    }
}

</style>
